module.exports = __webpack_public_path__ + "static/img/AM1.50e9946.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/labels/AM1.jpg
// module id = Pbat
// module chunks = 1